import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/react';
import { OnboardingKvStateSchema } from '@agentbrush/shared';
import type { OnboardingKvState } from '@agentbrush/shared';
import { useApiClient } from './use-api-client.js';

// Story 11.1 Task 0b: namespace React Query keys by Clerk userId so a session
// switch without full page reload cannot leak cached data between users.
export const onboardingQueryKey = (userId: string | null | undefined) =>
  ['onboarding', userId ?? 'anon'] as const;

export function useOnboardingState() {
  const { fetchApi } = useApiClient();
  const { userId } = useAuth();

  return useQuery<OnboardingKvState>({
    queryKey: onboardingQueryKey(userId),
    queryFn: async () => {
      const res = await fetchApi('/v1/onboard/state');
      if (!res.ok) throw new Error(`Status ${res.status}`);
      const body = await res.json();
      return OnboardingKvStateSchema.parse(body.data);
    },
    enabled: Boolean(userId),
    staleTime: 0, // Always stale — SSE drives updates (architecture.md line 735)
  });
}
